import React, { Component } from 'react'
import styled from 'styled-components'
import { get, findIndex } from 'lodash'
import { CarouselProvider, Slider, Slide } from 'pure-react-carousel'
import { toWidth, viewportWidth, viewportHeight } from 'helpers'
import HorizontalCentered from 'components/HorizontalCentered'
import VerticalCentered from 'components/VerticalCentered'
import { Overlay, ActionSheets, ConfirmDialog } from 'components/Modal'

import svgMore from 'assets/svg/icon-more.svg'
import svgClose from 'assets/svg/icon-close.svg'

export default class extends Component {
  state = {
    menusVisible: false
  }

  componentWillReceiveProps (nextProps) {
    if (get(this.props, 'currentPhoto._id') !== get(nextProps, 'currentPhoto._id')) {
      this.setState({ menusVisible: false, removeConfirmVisible: false })
    }
    if (get(this.props, 'coverSelecting') && !get(nextProps, 'coverSelecting')) {
      this.setState({ menusVisible: false, coverSelectConfirmVisible: false })
    }
  }

  render () {
    const { photos, currentPhoto, onClose, onRemove, onUnpin, removing, unpinning, onCoverSelect, coverSelecting } = this.props
    const initialCurrentSlide = findIndex(photos, photo => photo._id === get(currentPhoto, '_id'))
    if (initialCurrentSlide === -1) return null
    const currentSlidePhoto = photos[get(this.refs, '_carousel.carouselStore.state.currentSlide')]
    return (
      <FullscreenPhotoWrapper visible={get(currentPhoto, '_id') && (photos || []).length}>
        <CarouselProvider
          ref='_carousel'
          currentSlide={initialCurrentSlide}
          naturalSlideWidth={viewportWidth()}
          naturalSlideHeight={viewportHeight()}
          totalSlides={(photos || []).length}>
          <Slider>
            {(photos || []).map((photo, index) =>
              <Slide key={index} index={index}>
                <HorizontalCentered>
                  <VerticalCentered>
                    <Photo src={toWidth(get(photo, 'imagePath'), viewportWidth())} />
                  </VerticalCentered>
                </HorizontalCentered>
              </Slide>
            )}
          </Slider>
          <BtnClose onClick={onClose}>
            <IconClose src={svgClose} />
          </BtnClose>
          <BtnMore>
            <IconMoreWrapper onClick={() => this.setState({ menusVisible: !this.state.menusVisible })}>
              <IconMore src={svgMore} />
            </IconMoreWrapper>
            <ActionSheets
              topRight
              withoutOverlay={viewportWidth() > 768}
              visible={this.state.menusVisible}
              onCancel={() => this.setState({ menusVisible: false })}
              options={[
                onCoverSelect ? { key: 'change-cover', title: 'ตั้งเป็นภาพปกอัลบั้ม', onClick: () => this.setState({ coverSelectConfirmVisible: true }) } : undefined,
                onRemove ? { key: 'remove', title: 'ลบรูปภาพ', color: 'colorCoral', onClick: () => this.setState({ removeConfirmVisible: true }) } : undefined,
                onUnpin ? { key: 'unpin', title: 'ลบออกจากภาพไฮไลท์', onClick: () => this.setState({ unpinConfirmVisible: true }) } : undefined
              ].filter(obj => obj)} />
          </BtnMore>
        </CarouselProvider>
        <Overlay visible={this.state.coverSelectConfirmVisible}
          onClose={() => this.setState({ coverSelectConfirmVisible: false })}>
          <ConfirmDialog title='คุณต้องการตั้งภาพนี้เป็นภาพปกอัลบั้ม ?'
            loading={coverSelecting}
            onOkay={() => onCoverSelect(currentSlidePhoto)}
            onCancel={() => this.setState({ coverSelectConfirmVisible: false })} />
        </Overlay>
        <Overlay visible={this.state.removeConfirmVisible}
          onClose={() => this.setState({ removeConfirmVisible: false })}>
          <ConfirmDialog title='คุณต้องการลบรูปภาพนี้ ?'
            loading={removing}
            onOkay={() => onRemove(currentSlidePhoto)}
            onCancel={() => this.setState({ removeConfirmVisible: false })} />
        </Overlay>
        <Overlay visible={this.state.unpinConfirmVisible}
          onClose={() => this.setState({ unpinConfirmVisible: false })}>
          <ConfirmDialog title='คุณต้องการลบภาพนี้ออกจากภาพไฮไลท์ ?'
            loading={unpinning}
            onOkay={() => onUnpin(currentSlidePhoto)}
            onCancel={() => this.setState({ unpinConfirmVisible: false })} />
        </Overlay>
      </FullscreenPhotoWrapper>
    )
  }
}

const FullscreenPhotoWrapper = styled.div`
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  background-color: black;
  transition: opacity 0.3s ease;
  ${props => props.visible ? `
    opacity: 1;
    z-index: 15001;
  ` : `
    opacity: 0;
    z-index: -1;
  `}
`
const BtnClose = styled.div`
  position: absolute;
  left: 0px;
  top: 0px;
  bottom: 0px;
  width: 40px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  cursor: pointer;
`
const IconClose = styled.img`
  width: 16px;
  height: 16px;
  margin-top: 12px;
  vertical-align: top;
  filter: brightness(0) invert(1);
`
const BtnMore = styled.div`
  position: absolute;
  right: 0px;
  top: 0px;
  bottom: 0px;
  width: 40px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  cursor: pointer;
`
const IconMoreWrapper = styled.div`
  width: 40px;
  height: 40px;
  line-height: 40px;
  text-align: center;
`
const IconMore = styled.img`
  width: 16px;
  height: 16px;
  margin-top: 12px;
  vertical-align: top;
  filter: brightness(0) invert(1);
`
const Photo = styled.img`
  width: calc(100% - 10px);
  height: 100%;
  max-height: calc(100vh - 80px);
  object-fit: contain;
`



// WEBPACK FOOTER //
// ./src/components/FullscreenPhoto.js